export const findBestMatchingTagInput = ({
  assignedTags = [],
  gatewayInputs = [],
  tagType,
}: {
  assignedTags?: any[];
  gatewayInputs?: any[];
  tagType: string;
}): { tag: any; input: any } | null => {
  const filteredTags = assignedTags.filter(
    (tag) => tag?.tagName?.toLowerCase() === tagType.toLowerCase()
  );

  const matchedExact = filteredTags
    .map((tag) => {
      const input = gatewayInputs.find(
        (input) =>
          input.id === tag.assignedTagId && Number(input.value) === Number(tag.tagIndicatorValue)
      );
      return input ? { tag, input } : null;
    })
    .filter(Boolean) as { tag: any; input: any }[];

  if (matchedExact.length > 0) {
    return matchedExact.reduce((best, current) =>
      (current.tag.tagIndicatorPosition ?? Infinity) < (best.tag.tagIndicatorPosition ?? Infinity)
        ? current
        : best
    );
  }

  const matchedById = filteredTags
    .map((tag) => {
      const input = gatewayInputs.find((input) => input.id === tag.assignedTagId);
      return input ? { tag, input } : null;
    })
    .filter(Boolean) as { tag: any; input: any }[];

  if (matchedById.length === 0) return null;

  return matchedById.reduce((best, current) =>
    (current.tag.tagIndicatorPosition ?? Infinity) < (best.tag.tagIndicatorPosition ?? Infinity)
      ? current
      : best
  );
};
